import {NgModule} from '@angular/core';
import {CommonModule, DatePipe} from '@angular/common';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DateAdapter, MatNativeDateModule} from '@angular/material/core';
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {MatTableModule} from '@angular/material/table';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatSelectModule} from '@angular/material/select';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatTabsModule} from '@angular/material/tabs';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatRadioModule} from '@angular/material/radio';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatBadgeModule} from '@angular/material/badge';
import {MatTreeModule} from '@angular/material/tree';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatListModule} from '@angular/material/list';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatMenuModule} from '@angular/material/menu';
import {MatSortModule} from '@angular/material/sort';
import {MatStepperModule} from '@angular/material/stepper';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatCardModule} from '@angular/material/card';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {ObdCapturePlaceholderComponent} from '../../obd/obd-common/components/obd-capture-placeholder/obd-capture-placeholder.component';
import {ObdBulkApplicationImportComponent} from '../../obd/obd-common/components/obd-bulk-application-import/obd-bulk-application-import.component';
import {ObdBulkApplicationRowEditComponent} from '../../obd/obd-common/components/obd-bulk-application-row-edit/obd-bulk-application-row-edit.component';

// components
import {ContentFieldComponent} from '../components/content-field/content-field.component';
import {DeathStatusIconComponent} from '../components/death-status-icon/death-status-icon.component';
import {
  BusySpinnerIconComponent,
  DialogHeadingComponent,
  ElementSelectComponent,
  ElementDateRangeComponent,
  ElementSlideToggleComponent,
  ElementInputComponent,
  OpenLinkAsComponent,
  DuplicateComponent,
  InfoPanelComponent
} from '../components';
import {ElementMultiselectComponent} from '../components/elements/element-multi-select/element-multi-select.component';
import {ElementCheckboxComponent} from '../components/elements/element-checbox/element-checkbox.component';
import {PageHeadingComponent} from '../components/page-heading/page-heading.component';
import {BannerComponent} from '../components/banner/banner.component';
import {UserManagementViewComponent} from '../../other/components';
import {TabsHeaderComponent} from '../components/tabs-header/tabs-header.component';
import {PermissionDeniedComponent} from '../components/permission-view/permission-denied.component';
import {SupportViewComponent} from '../../other/components/pages/support-view/support-view.component';
import {AddNotesDialogComponent} from '../components/dialogs/add-notes-dialog/add-notes-dialog.component';
import {CopyToClipboardButtonComponent} from '../components/copy-to-clipboard-button/copy-to-clipboard-button.component';
import {ContentDisplayDialogComponent} from '../../other/components/dialogs/content-display-dialog/content-display-dialog.component';
import {PrettyPrintTextPipe} from '../pipes/pretty-print-text.pipe';
import {CustomDateAdapter} from '../util/MomentDateAdapter';
import {environment} from '../../../../environments/environment';
import {Base64ImageComponent} from '../components/base64mage/base64Image.component';
import {HeartComponent} from '../components/svgs/heart/heart.component';
import {CustomTooltipComponent} from '../components/custom-tooltip/custom-tooltip.component';
import {UpdownArrowComponent} from '../components/svgs/updown-arrow/updown-arrow.component';
import {HealthScoreGuageModule} from './health-score-guage/health-score-guage.module';
import {StatusIndicatorComponent} from '../components/svgs/status-indicator/status-indicator.component';
import {IconNavigateComponent} from '../components/icon-navigate/icon-navigate.component';
import {AddressFormComponent} from '../components/common-steps/address-form/address-form.component';
import {ContactFormComponent} from '../components/common-steps/contact-form/contact-form.component';
import {GenericListDialogComponent} from '../dialogs/generic-list-dialog/generic-list-dialog.component';
import {
  GenericReasoningDialogComponent
} from '../components/dialogs/generic-reasoning-dialog/generic-reasoning-dialog.component';
import {GreydomHintComponent} from '../components/hint/greydom-hint.component';
import {ButtonTextMatchDirective} from '../directive/button-text-match.directive';
import {DefaultMatSortStartDirective} from '../directive/default-mat-sort-start.directive';
import {TruncateTextPipe} from '../pipes';
import {FileUploadComponent} from '../components/file-upload/file-upload.component';
import {AdhocIdVerificationDialogComponent} from '../../other/components/dialogs/adhoc-id-verification-dialog/adhoc-id-verification-dialog.component';
import {
  AdhocBankVerificationDialogComponent
} from '../../other/components/dialogs/adhoc-bank-verification-dialog/adhoc-bank-verification-dialog.component';
import {ElementDatePickerComponent} from '../components/elements/element-date-picker/element-date-picker-component.component';
import {ProductFilterComponent} from '../components/product-filter/product-filter.component';

const modules: any[] = [
  CommonModule,
  RouterModule,
  MatSidenavModule,
  MatToolbarModule,
  MatListModule,
  MatIconModule,
  MatTableModule,
  MatButtonModule,
  MatDialogModule,
  MatFormFieldModule,
  MatInputModule,
  FormsModule,
  ReactiveFormsModule,
  MatSnackBarModule,
  MatMenuModule,
  MatProgressSpinnerModule,
  MatPaginatorModule,
  MatSortModule,
  MatStepperModule,
  MatGridListModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatSelectModule,
  MatAutocompleteModule,
  MatTabsModule,
  MatCheckboxModule,
  MatTooltipModule,
  MatRadioModule,
  MatSlideToggleModule,
  MatBadgeModule,
  MatTreeModule,
  MatCardModule,
  ClipboardModule,
  HealthScoreGuageModule
];

const dialogs: any[] = [
  AddNotesDialogComponent,
  ContentDisplayDialogComponent,
  AdhocIdVerificationDialogComponent,
  AdhocBankVerificationDialogComponent
];

const pipes: any[] = [
  PrettyPrintTextPipe,
  TruncateTextPipe,
  ContentDisplayDialogComponent
];

const elementComponents: any[] = [
  ElementSelectComponent,
  ElementCheckboxComponent,
  ElementSlideToggleComponent,
  ElementMultiselectComponent,
  ElementDateRangeComponent,
  ElementInputComponent,
  ElementDatePickerComponent,
  ProductFilterComponent
];

const sharedComponents: any[] = [
  BusySpinnerIconComponent,
  ContentFieldComponent,
  PageHeadingComponent,
  DeathStatusIconComponent,
  DialogHeadingComponent,
  BannerComponent,
  TabsHeaderComponent,
  Base64ImageComponent,
  CustomTooltipComponent,
  OpenLinkAsComponent,
  IconNavigateComponent,
  PermissionDeniedComponent,
  CopyToClipboardButtonComponent,
  ButtonTextMatchDirective,
  DefaultMatSortStartDirective,
  GenericListDialogComponent,
  GenericReasoningDialogComponent,
  GreydomHintComponent,
  FileUploadComponent,
  InfoPanelComponent
];

const svgs: any[] = [
  HeartComponent,
  UpdownArrowComponent,
  StatusIndicatorComponent
];

const pagesComponents: any[] = [
  UserManagementViewComponent,
  SupportViewComponent
];

const pagesSharedComponents: any[] = [
  AddressFormComponent,
  ContactFormComponent,
  DuplicateComponent
];

const featObdApplication = [
  ObdCapturePlaceholderComponent,
  ObdBulkApplicationImportComponent,
  ObdBulkApplicationRowEditComponent
];

const components: any[] = [
  ...pagesComponents,
  ...pagesSharedComponents,
  ...sharedComponents,
  ...elementComponents,
  ...featObdApplication,
  ...dialogs,
  ...pipes,
  ...svgs,
];

const providers = [
  {
    provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS,
    useValue: {useUtc: environment.timeZone === 'UTC'}
  },
  {
    provide: DateAdapter,
    useClass: CustomDateAdapter
  },
];

@NgModule({
  declarations: [...components],
  imports: [...modules],
  exports: [...modules, ...components],
  providers: [
    DatePipe,
    ...providers
  ]
})
export class GreydomCommonModule {
}
